/**
 * Modal genérico que muestra las notas y alertas de un cliente.
 * Se puede invocar desde POS, agenda, comanda o cualquier módulo.
 *
 * Uso:
 *   {showAlert && (
 *     <ClientAlertModal
 *       clientName="Juan Pérez"
 *       notes="Cliente frecuente, prefiere horario mañana"
 *       conflictNotes="Alergia al amoniaco"
 *       onClose={() => setShowAlert(false)}
 *     />
 *   )}
 */

interface ClientAlertModalProps {
  clientName?: string;
  notes?: string | null;
  conflictNotes?: string | null;
  onClose: () => void;
}

const ClientAlertModal = ({ clientName, notes, conflictNotes, onClose }: ClientAlertModalProps) => {
  const hasAlerts = !!conflictNotes;
  const hasNotes = !!notes;
  const isEmpty = !hasAlerts && !hasNotes;

  return (
    <div
      style={{
        position: "fixed", inset: 0, background: "rgba(0,0,0,0.4)",
        display: "flex", justifyContent: "center", alignItems: "center", zIndex: 9999,
      }}
      onClick={onClose}
    >
      <div
        style={{
          background: "#fff", borderRadius: 12, padding: "24px 28px",
          width: 480, maxWidth: "90vw", maxHeight: "80vh", overflowY: "auto",
          boxShadow: "0 8px 32px rgba(0,0,0,0.18)",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <h2 style={{ margin: "0 0 16px", fontSize: 18, color: "#1f1b2e" }}>
          Notas del cliente
        </h2>
        {clientName && (
          <p style={{ fontSize: 14, color: "#45348e", fontWeight: 600, marginBottom: 16 }}>
            {clientName}
          </p>
        )}

        {isEmpty ? (
          <p style={{ color: "#999", padding: 10, textAlign: "center" }}>
            Este cliente no tiene notas ni alertas registradas.
          </p>
        ) : (
          <>
            {hasAlerts && (
              <div style={{
                padding: "12px 16px", borderRadius: 8, marginBottom: 12,
                background: "#fef2f2", border: "1px solid #fecaca",
              }}>
                <p style={{ fontSize: 12, fontWeight: 700, color: "#b91c1c", marginBottom: 4 }}>
                  ⚠️ Alerta
                </p>
                <p style={{ fontSize: 13, color: "#7f1d1d", lineHeight: 1.5, whiteSpace: "pre-wrap" }}>
                  {conflictNotes}
                </p>
              </div>
            )}
            {hasNotes && (
              <div style={{
                padding: "12px 16px", borderRadius: 8,
                background: "#fffbeb", border: "1px solid #fde68a",
              }}>
                <p style={{ fontSize: 12, fontWeight: 700, color: "#92400e", marginBottom: 4 }}>
                  📝 Notas generales
                </p>
                <p style={{ fontSize: 13, color: "#78350f", lineHeight: 1.5, whiteSpace: "pre-wrap" }}>
                  {notes}
                </p>
              </div>
            )}
          </>
        )}

        <div style={{ marginTop: 20, textAlign: "right" }}>
          <button
            onClick={onClose}
            style={{
              padding: "10px 20px", border: "1px solid #d0cde1", borderRadius: 8,
              background: "#fff", color: "#45348e", fontWeight: 600, cursor: "pointer", fontSize: 14,
            }}
          >
            Cerrar
          </button>
        </div>
      </div>
    </div>
  );
};

export default ClientAlertModal;
